import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pathitem"
    }}>{`PathItem`}</h1>
    <p>{`A path or drawing object, such as the outline of a shape or a straight or curved line,
which contains sub paths defining its geometry.`}</p>
    <p>{`Access through the collection in the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#pathitems"
      }}>{`Document.pathItems`}</a>{` property. For example, this selects a named path item:`}</p>
    <pre><code parentName="pre" {...{}}>{`const currentPathItem = app.activeDocument.pathItems.getByName("myPath");
currentPathItem.select()
`}</code></pre>
    <p>{`Create these objects by passing a set of SubPathInfo objects to the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitems/#add"
      }}>{`PathItems.add`}</a>{`() method. This method creates
a `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
      }}>{`SubPathItem`}</a>{` object for each `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
      }}>{`SubPathInfo`}</a>{` object, and creates and returns a new `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}>{`PathItem`}</a>{` object for the
path represented by all of the subpaths.`}</p>
    <p><em parentName="p">{`Added in Photoshop 23.3`}</em></p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`docId`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The ID of the document of this pathItem.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`For use with batchPlay operations. This pathItem ID, along with its document ID can be used to represent this pathItem for the lifetime of this document.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`kind`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#pathkind"
            }}><em parentName="a">{`PathKind`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The type of this path`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of this path`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/document/"
            }}><em parentName="a">{`Document`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Owner document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`subPathItems`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/subpathitems/"
            }}><em parentName="a">{`SubPathItems`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The contained `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/subpathitem/"
            }}>{`SubPathItem`}</a>{`s in this path`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced PathItem object`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "deselect"
    }}>{`deselect`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Deselects this `}<inlineCode parentName="p">{`pathItem`}</inlineCode>{` object.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "duplicate"
    }}>{`duplicate`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}><em parentName="a">{`PathItem`}</em></a>{`>`}</p>
    <p>{`Duplicates the `}<inlineCode parentName="p">{`pathItem`}</inlineCode>{` object with the new name, returning the duplicate.`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "fillpath"
    }}>{`fillPath`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Fills the area enclosed by this path.`}</p>
    <p><inlineCode parentName="p">{`opacity`}</inlineCode>{` is a percentage, in the `}<inlineCode parentName="p">{`[0.0 ... 100.0]`}</inlineCode>{` range.`}</p>
    <p><inlineCode parentName="p">{`feather`}</inlineCode>{` is in pixels, in the `}<inlineCode parentName="p">{`[0.0 ... 250.0]`}</inlineCode>{` range.`}</p>
    <p>{`If `}<inlineCode parentName="p">{`wholePath`}</inlineCode>{` is true, all subpaths are used when doing the fill.`}</p>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`fillColor?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/solidcolor/"
            }}><em parentName="a">{`SolidColor`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`mode?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#colorblendmode"
            }}><em parentName="a">{`ColorBlendMode`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`opacity`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`100.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`preserveTransparency`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`feather`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`wholePath`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`true`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`antiAlias`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`true`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "makeclippingpath"
    }}>{`makeClippingPath`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Makes this the clipping path for this document.`}</p>
    <p><inlineCode parentName="p">{`flatness`}</inlineCode>{` tells the PostScript printer how to approximate curves in the path.`}</p>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`flatness?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "makeselection"
    }}>{`makeSelection`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Makes a selection object whose border is this path.`}</p>
    <p><inlineCode parentName="p">{`feather`}</inlineCode>{` is in pixels, in the range `}{`[0.0...250.0]`}</p>
    <p><inlineCode parentName="p">{`operation`}</inlineCode>{`, by default, is `}<inlineCode parentName="p">{`SelectionType.REPLACE`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`feather?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`antiAlias?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`operation?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#selectiontype"
            }}><em parentName="a">{`SelectionType`}</em></a></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "remove"
    }}>{`remove`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Deletes this object`}</p>
    <hr></hr>
    <h3 {...{
      "id": "select"
    }}>{`select`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Makes this the active or selected `}<inlineCode parentName="p">{`PathItem`}</inlineCode>{` object`}</p>
    <hr></hr>
    <h3 {...{
      "id": "strokepath"
    }}>{`strokePath`}</h3>
    <p><em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Strokes the path with the specified tool`}</p>
    <p><inlineCode parentName="p">{`tool`}</inlineCode>{` is optional, and by default will use `}<inlineCode parentName="p">{`ToolType.PENCIL`}</inlineCode></p>
    <p><inlineCode parentName="p">{`simulatePressure`}</inlineCode>{` is false by default.`}</p>
    <p>{`If the tool is `}<inlineCode parentName="p">{`ToolType.CLONESTAMP`}</inlineCode>{` or `}<inlineCode parentName="p">{`ToolType.HEALINGBRUSH`}</inlineCode>{`, `}<inlineCode parentName="p">{`sourceOrigin`}</inlineCode>{` must be provided as a
an object with x and y properties (in pixels) to indicate the location of the stroke source. `}<inlineCode parentName="p">{`sourceLayer`}</inlineCode>{`
is optional, and by default will use the active layer in the document.`}</p>
    <h4 {...{
      "id": "parameters-4"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`tool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#tooltype"
            }}><em parentName="a">{`ToolType`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`simulatePressure`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sourceOrigin?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`object`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sourceOrigin.x`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sourceOrigin.y`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sourceLayer?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/layer/"
            }}><em parentName="a">{`Layer`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      